import React from 'react'

import { Categories } from './categories'
import { TopBarContainer } from './top-bar-styled'

export const TopBar = ({ types, selectedType, onSelectType }) => {
  return (
    <TopBarContainer aria-label="Categorías del catálogo">
      <Categories
        types={types}
        selectedType={selectedType}
        onSelect={onSelectType}
      />
    </TopBarContainer>
  )
}
